import { AdvancedIntegrationHub } from "@/components/AdvancedIntegrationHub";

export default function IntegrationHub() {
  return <AdvancedIntegrationHub />;
}